import { PropsWithChildren } from 'react'

import styles from './PageControls.module.scss'

interface PageNumberProps extends PropsWithChildren {
  active?: boolean
  className?: string
  onClick: (() => void) | undefined
}
const PageNumber = ({ active = false, children, className, onClick }: PageNumberProps) => (
  <div
    className={[styles.pageNumber, active ? styles.active : undefined, className].join(' ')}
    onClick={onClick}
  >
    {children}
  </div>
)

export default PageNumber
